export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "incomingCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incoming call"])},
        "statuses": {
          "pause": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paused"])}
        },
        "errors": {
          "486": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destination number is busy"])},
          "408": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destination number is busy"])},
          "487": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Request terminated"])},
          "603": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Call was rejected"])},
          "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invalid number"])},
          "480": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destination number is unavailable"])},
          "402": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insufficient funds"])},
          "ENDED": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Request terminated"])}
        }
      },
      "ru": {
        "incomingCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Входящий звонок"])},
        "statuses": {
          "pause": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пауза"])}
        },
        "errors": {
          "486": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Набранный номер занят"])},
          "408": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Набранный номер занят"])},
          "487": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вызов завершен"])},
          "603": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вызов отклонен"])},
          "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неверный номер"])},
          "480": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер недоступен"])},
          "402": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Недостаточно средств"])},
          "ENDED": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вызов завершен"])}
        }
      }
    }
  })
}
